import { render, staticRenderFns } from "./InvoicesInTableActions.vue?vue&type=template&id=185067a8&"
import script from "./InvoicesInTableActions.vue?vue&type=script&lang=js&"
export * from "./InvoicesInTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports